var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8a5.5 5.5 0 1 1 11 0v2a7.5 7.5 0 0 0 1.5 4.5l.214.286a3.5 3.5 0 0 1 .13.18 1 1 0 0 1-.765 1.53c-.04.004-.1.004-.222.004H5.643c-.122 0-.183 0-.222-.003a1 1 0 0 1-.766-1.532c.021-.033.058-.082.13-.18L5 14.5A7.5 7.5 0 0 0 6.5 10V8Z",
    stroke: "#0E1012"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.585 18.647a2.5 2.5 0 0 0 4.83 0",
    stroke: "#0E1012",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOutlineIcon);
export default __webpack_public_path__ + "static/media/notification-outline-icon.36c72a679953846a7aac3d6bbb66651e.svg";
export { ForwardRef as ReactComponent };